import { mutationOptions } from '../../common/utils';
import { analyticsAPIClient } from '../analyticsAPIClient';
import { ANALYTICS_QUERY_KEYS } from './keys';
import type { AnalyticsEventRequest } from './types';

export const ANALYTICS_QUERIES = {
  trackEvent: () => {
    return mutationOptions({
      mutationFn: (payload: AnalyticsEventRequest) =>
        analyticsAPIClient.trackEvent(payload),
      mutationKey: ANALYTICS_QUERY_KEYS.trackEvent(),
    });
  },
};
